import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from '../SectionTitle/SectionTitle';
import sImg1 from '../../images/home/dummy-img.jpeg'
import sImg2 from '../../images/home/dummy-img.jpeg'
import sImg3 from '../../images/home/dummy-img.jpeg'


const testimonials = [
    {
        id: '01',
        img: sImg1,
        Des: "We’ve been sourcing PP woven bags from SNBS Industries for over two years, and their product quality and timely delivery have always exceeded our expectations.",
        title: 'Pradnya Waghmare',
        sub: "Procurement Manager, Mahatech Packaging",
    },
    {
        id: '02',
        img: sImg2,
        Des: "The team at SNBS is highly professional and committed. Their customized solutions and consistent product standards make them our preferred supplier for polymer packaging needs.",
        title: 'Shraddha Kulkarni',
        sub: "Director, FreshFarm Organics",
    },
    {
        id: '03',
        img: sImg3,
        Des: "We ordered corrugated boxes and BOPP bags, and the quality was absolutely exceptional. SNBS’s dedication to customer satisfaction and service truly stands out.",
        title: 'Nikhil Deshmukh',
        sub: "Director, FreshFarm Organics",
    },

]

const TestimonialS2 = () => {

    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
            }
        }

        ]
    };

    return (
        <section className="wpo-testimonial-section-s2">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 col-12">
                        <div className="wpo-testimonial-right">
                            <SectionTitle subtitle={'HAPPY CUSTOMER'} title={'What clients say?'} />
                            <div className="testimonial-active">
                                <Slider {...settings}>
                                    {testimonials.map((testimonial, item) => (
                                        <div className="wpo-testimonial-item" key={item}>
                                            <div className="wpo-testimonial-slide">
                                                <div className="wpo-testimonial-slide-inner">
                                                    <ul>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                    </ul>
                                                    <p>{testimonial.Des}</p>
                                                </div>
                                                <div className="wpo-testimonial-client">
                                                    <div className="wpo-testimonial-client-img">
                                                        <img src={testimonial.img} alt="" height="80"/>
                                                    </div>
                                                    <div className="wpo-testimonial-client-text">
                                                        <h4>{testimonial.title}</h4>
                                                        <span>{testimonial.sub}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialS2;